import React from 'react';
import { ProFormSelect } from '@ant-design/pro-form';
import { useQuery } from '@apollo/client';
import PropTypes from 'prop-types';
import { PLACEHOLDER } from 'constants/form';
import { GET_USER_FROM_HRO_STAFF } from 'gql/users';
import { selectedHroStaffContext } from 'components/systemSetting/users/UserForm';
import selectUserOptionItemRender from '../SelectUser/selectUserOptionItemRender';

const SelectUserFromHroStaff = ({ name, department, faculty, ...props }) => {
  const { loading, refetch } = useQuery(GET_USER_FROM_HRO_STAFF, {
    variables: {
      first: 10,
    },
  });
  const { setSelectedHroStaff } = React.useContext(selectedHroStaffContext);

  return (
    <ProFormSelect
      showSearch
      width="xl"
      placeholder={PLACEHOLDER.PLEASE_SELECT}
      params={{ department, faculty }}
      debounceTime={process.env.REACT_APP_DEBOUNCE_TIME}
      request={async ({ keyWords, department, faculty }) => {
        const refetchData = await refetch({
          keyword: keyWords,
          department: department,
          faculty: faculty,
          first: 10,
        });
        const results = refetchData?.data?.usersFromHroStaff.map((user) => {
          const { id, readableName, netId } = user;
          return {
            value: id,
            label: `${readableName} (${netId})`,
            user,
          };
        });
        if (!loading && keyWords === '') return results;

        return results;
      }}
      rules={[
        {
          required: true,
          message: 'Please select user!',
        },
      ]}
      fieldProps={{
        filterOption: false,
        optionItemRender: selectUserOptionItemRender,
        onSelect: (_value, option) => {
          setSelectedHroStaff(option.user);
        },
      }}
      name={name}
      {...props}
    />
  );
};

SelectUserFromHroStaff.defaultProps = {
  initialValues: {},
};

SelectUserFromHroStaff.propsType = {
  name: PropTypes.string.isRequired,
  department: PropTypes.string,
  faculty: PropTypes.string,
};

export default SelectUserFromHroStaff;
